module.exports = __webpack_public_path__ + "static/media/front.4555c30c.svg";